export class PaginationMetadata {
  first = 1;
  last = 1;
  total_num_items = 0;
  items_per_page = 0;
  current = 1;
}
